module.exports = __webpack_public_path__ + "img/bz2.76fed979.jpg";